export default __webpack_public_path__ + "static/media/warning--roadworks--g9.f504fc37.png";